export * as Azure from './azure';
